import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import GenericButton from '../shared/Button';
import IconicHeader from '../shared/IconicHeader';
import StakingBottom from './StakingBottom';
import StakingTop from './StakingTop';
import InfoButton from '../InfoButton';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '1400px',
    width: '100%',
    padding: '0px',
    paddingTop: '50px',

    margin: '50px auto 50px auto', // Center the container
    position: 'relative', // Center the container
  },
  subscribeWrapper: {
    margin: '70px 0px',
    padding: '50px 20px',
    background: theme.palette.mode === 'dark' ? 'black' : theme.palette.divider,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      fontSize: '36px',
      fontWeight: 'bold',
      color: theme.palette.text.primary,
      [theme.breakpoints.down('md')]: {
        fontSize: '24px',
      },
    },
  },
}));

const Staking = () => {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState('Staking');
  const [refresh, setRefresh] = useState(false);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleRefresh = () => {
    setRefresh(true);
  };

  return (
    <>
      <div className={classes.container}>
        <IconicHeader selectedTab={selectedTab} onChange={handleTabChange} />
        <div style={{ maxWidth: '1280px', width: '100%', margin: 'auto' }}>
          <h2 style={{ marginLeft: '20px' }}>
            Staking
            <InfoButton page={'Staking'} />
          </h2>
          <StakingTop onStakeSuccess={handleRefresh} />
          <StakingBottom refresh={refresh} />
        </div>
      </div>
    </>
  );
};

export default Staking;
